import { jsx as t, jsxs as l } from "react/jsx-runtime";
import { tv as a } from "tailwind-variants";
import m from "./Icon.js";
const o = a({
  base: ["pt-1"]
}), c = ({ children: e, icon: s }) => /* @__PURE__ */ l("li", { className: "flex gap-3", children: [
  /* @__PURE__ */ t(
    m,
    {
      className: o({ class: s.className }),
      name: s.name,
      style: s.style
    }
  ),
  /* @__PURE__ */ t("span", { children: e })
] }), n = a({
  base: ["flex", "flex-col", "gap-4", "list-none"]
}), r = ({ className: e, children: s }) => /* @__PURE__ */ t("ul", { className: n({ class: e }), children: s });
r.Item = c;
export {
  r as default
};
